import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import Modal from '../../../Util/Modal/CustomModal';
import { useSelector, useDispatch } from 'react-redux';

function CustomListContainer(props) {
  const defaultPropsForm = {
    labelTitle: 'Lista',
    labelTitleButtonAdd: 'Incluir novo item',
    canAdd: false,
    pathAdd: '',
    content: '',
    icon: 'fa-pen-to-square',
    primary_color: '#000'
  }
  let list = { ...defaultPropsForm, ...props };
  if (list.list) {
    list.list.key_data_rows = `custom_list_data_${props.list.endpoint}`;
    if (list.list.canAdd != undefined) {
      list.canAdd = list.list.canAdd;
    }
  }

  const navigate = useNavigate();
  const showModal = useSelector((state) => { return state.core.session.custom_form_show_modal });
  const modalContent = useSelector((state) => { return state.core.session.custom_form_content_modal });
  const dispatch = useDispatch();
  let [modalTitle, setModalTitle] = useState('');

  const setShowModal = status => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: status });
  }

  const setModalContent = content => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_content_modal', value: content });
  }

  return (
    <>
      <Modal
        show={showModal}
        handleShow={() => setShowModal(true)}
        handleClose={() => setShowModal(false)}
        title={modalTitle}
        content={modalContent}
        showButtons={false}
        showHeader={false}
      />
      <section className="content pr-3 pl-3" style={{ marginTop: '30px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card card-outline" style={{ borderTop: `3px solid ${list.primary_color}` }}>
                <div className="card-header" style={{ borderBottom: '0' }}>
                  <h3 className="card-title"><i className={`fa-solid ${list.icon} mr-1`}></i>{list.labelTitle}</h3>
                  {list.urlHome && (
                    <a onClick={() =>
                      window.location = list.urlHome
                    } className="btn btn-secondary float-right" data-tip data-for="registerTip">Home</a>
                  )}
                  <ReactTooltip id="registerTip" place="top" effect="solid">
                    {list.labelTitleButtonAdd}
                  </ReactTooltip>
                </div>
                {/* /.card-header */}
                {list.content}
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </>
  );
}
export default CustomListContainer;
